// Clientes de confianza: pueden llevarse el equipo sin pagar todo, hasta su límite.
import { el, clear } from '../../utils/dom.js';
import { Rentals, Clients } from '../../api/resources.js';
import { fmtMoney } from '../../utils/format.js';
import { field, readForm } from '../../components/form.js';
import { ok, err } from '../../components/toast.js';

export default async function RentalsCreditoPage(outlet) {
  clear(outlet);
  let creditos = [];
  let clientes = [];
  try {
    [creditos, clientes] = await Promise.all([Rentals.creditos(), Clients.list({ limit: 1000 }).then((r) => r.data || [])]);
  } catch (ex) { outlet.innerHTML = `<div class="empty">Error: ${ex.message}</div>`; return; }

  outlet.appendChild(el('div', { class: 'page-head' },
    el('div', {}, el('h1', {}, 'Clientes de confianza'),
      el('div', { class: 'muted' }, 'Pueden llevarse el equipo sin pagar todo, hasta su límite de crédito.')),
    el('a', { href: '#/rentals', class: 'btn ghost' }, '← Rentas'),
  ));

  const conCredito = new Set(creditos.map((c) => c.client_id));
  const lista = el('div', { class: 'rp-main' });
  const lado = el('aside', { class: 'rp-aside' });
  outlet.appendChild(el('div', { class: 'rp-grid' }, lista, lado));

  if (!creditos.length) {
    lista.appendChild(el('div', { class: 'card' }, el('p', { class: 'muted' },
      'Ningún cliente tiene crédito todavía. Sin crédito, una renta solo se entrega pagada completa.')));
  }
  for (const c of creditos) {
    const e = c.estado || {};
    const det = el('details', { class: 'card mb-3' },
      el('summary', { class: 'flex justify-between gap-2 wrap', style: 'cursor:pointer' },
        el('span', {}, el('strong', {}, c.client?.full_name || 'Cliente'),
          !c.activo ? el('span', { class: 'badge muted', style: 'margin-left:8px' }, 'Pausado') : null,
          e.con_atraso ? el('span', { class: 'badge danger', style: 'margin-left:8px' }, 'Pagos vencidos') : null),
        el('span', { class: 'muted text-sm' }, `Debe ${fmtMoney(e.deuda || 0)} de ${fmtMoney(c.limite)} · ${c.dias_pago} días`)),
      formulario(c.client_id, c),
    );
    lista.appendChild(det);
  }

  lado.appendChild(el('section', { class: 'card' },
    el('h3', { class: 'rp-h' }, 'Dar crédito'),
    formulario(null, null, clientes.filter((x) => !conCredito.has(x.id)))));

  function formulario(clientId, c, opciones) {
    const form = el('form', { class: 'mt-3', onsubmit: async (ev) => {
      ev.preventDefault();
      const d = readForm(form);
      const cid = clientId || d.client_id;
      if (!cid) { err('Elige un cliente'); return; }
      try {
        await Rentals.guardarCredito(cid, {
          limite: Number(d.limite || 0), dias_pago: Number(d.dias_pago || 0),
          bloquear_con_atraso: !!d.bloquear, activo: !!d.activo, vence_el: d.vence_el || null, notas: d.notas || null,
        });
        ok('Crédito guardado');
        RentalsCreditoPage(outlet);
      } catch (ex) { err(ex.message); }
    } },
    !clientId ? field({ name: 'client_id', label: 'Cliente', type: 'select', required: true,
      options: (opciones || []).map((x) => ({ value: x.id, label: x.full_name })) }) : null,
    el('div', { class: 'form-grid' },
      field({ name: 'limite', label: 'Límite de crédito', type: 'number', step: '0.01', min: 0, required: true, value: c?.limite ?? '' }),
      field({ name: 'dias_pago', label: 'Días para pagar', type: 'number', min: 0, max: 365, required: true, value: c?.dias_pago ?? 15 }),
    ),
    field({ name: 'vence_el', label: 'Vence el (opcional)', type: 'date', value: c?.vence_el || '' }),
    field({ name: 'bloquear', label: 'No darle crédito si tiene pagos vencidos', type: 'checkbox', value: c ? c.bloquear_con_atraso : true }),
    field({ name: 'activo', label: 'Crédito activo', type: 'checkbox', value: c ? c.activo : true }),
    field({ name: 'notas', label: 'Notas (opcional)', value: c?.notas || '' }),
    el('button', { class: 'btn primary', type: 'submit' }, 'Guardar crédito'));
    return form;
  }
}
